<template>
  <span>
    <el-popover
      ref="popover5"
      placement="top-start"
      width="360"
      v-model="showModal"
    >
      <img
        v-for="(v, i) in emojiList"
        :src="'/static/emoji/' + v"
        :key="i"
        @click="selectEmoji(i)"
        class="img-style"
      />
    </el-popover>
    <i class="chat iconfont iconsmile1" v-popover:popover5></i>
  </span>
</template>

<script>
import emoji from '@/utils/emoji'

export default {
  data() {
    return {
      emojiList: emoji.obj,
      currentEmoji: '',
      showModal: false
    }
  },
  methods: {
    selectEmoji(e) {
      let value = (this.inpMessage || '') + e
      this.$data.showModal = false
      this.$emit('selectEmoji', value)
    }
  },
  props: {
    inpMessage: String
  }
}
</script>
<style scoped>
.img-style {
  width: 22px;
  margin: 5px;
  cursor: pointer;
}
.img-style:hover {
  background-color: aquamarine;
}
.chat.iconfont {
  margin-right: 10px;
  margin-left: 10px;
  font-size: 25px;
}
</style>
